//import axios from "axios";
import ApiService from "@/core/services/api.service";
//import { OBTENER_SUB_PREGUNTAS_POR_PREGUNTA } from "./preguntas/subpregunta.module";
// action types
export const OBTENER_PREGUNTAS = "obtenerPreguntas";
export const OBTENER_PREGUNTAS_POR_INDICE = "obtenerPreguntasPorIndice;"
export const OBTENER_PREGUNTA = "obtenerPregunta";
export const REGISTRAR_PREGUNTA = "registrarPregunta";
export const ACTUALIZAR_PREGUNTA = "actualizarPregunta";

export const OBTENER_PREGUNTAS_RESPUESTAS_MV_POR_INDICE = "obtenerPreguntasRespuestasMvPorIndice";

export const OBTENER_TODAS_PREGUNTAS_POR_INDICE = "obtenerTopasPreguntasPorIndice";
// mutation types
export const SET_PREGUNTAS = "setIndices";
export const SET_PREGUNTA = "setIndice";

const state = {
    preguntas:[],
    pregunta:[],
    data: [
        {id:1, textoPregunta: '¿Cuántos cocodes están registrados?', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: null}, 
        {id:2, textoPregunta: 'Primer Nivel', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 1},
        {id:3, textoPregunta: 'Segundo Nivel', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: 1},
        {id:4, textoPregunta: '¿Cuenta con reglamento aprobado?', estadosId: 1, estado: 'Activo', indicesId: 1, preguntasId: null},
        {id:5, textoPregunta: '¿Cuántos síndicos y concejales están registrados?', estadosId: 2, estado: 'Inactivo', indicesId: 1, preguntasId: null},
        {id:6, textoPregunta: '¿Cuantas reuniones ha realizado durante este periodo?', estadosId: 1, estado: 'Activo', indicesId: 2, preguntasId: null}],
    
}

const getters = {
    obtenerPreguntas(state) {
      return state.preguntas;
    },
}

const actions = {
    async [OBTENER_PREGUNTAS](context, estadoId) {

        let endpoint = 'api/Preguntas'
        if(estadoId){
            endpoint = `api/Preguntas/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Obtener Listado de preguntas por indice seleccionado
     * @param {*} context 
     * @param {*} indiceId 
     */
    async [OBTENER_PREGUNTAS_POR_INDICE](context, datos){
        let endpoint = `api/Preguntas/Indice/${datos.indiceId}`
        if(datos.estadoId){
            endpoint = `api/Preguntas/Estado/${datos.estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });  
    },

    async [OBTENER_PREGUNTAS_RESPUESTAS_MV_POR_INDICE](context, datos){
        let endpoint = `api/Preguntas/Respuestas/Mv/Indice/${datos.indiceId}`
       
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });  
    },

    async [OBTENER_PREGUNTA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Preguntas/`)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [REGISTRAR_PREGUNTA](context, datosPregunta){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Preguntas`, datosPregunta)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_PREGUNTA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Preguntas/`, datos.datosPregunta)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Obtener todas las preguntas por indice sin la estructura de pregutna -> subpregunta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_TODAS_PREGUNTAS_POR_INDICE](context, indiceId){

        let endpoint = `api/Preguntas/ListaUnica/Indice/${indiceId}`
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
        
    }

}

const mutations = {
    [SET_PREGUNTAS](state, data) {
        state.preguntas = data;
    },

    [SET_PREGUNTA](state, data) {
        state.pregunta = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}